
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_7f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as advicefLPJtIIEMRoSgejQrkg591HRZ2ZuZ81CzO5cQqXyoPMMeta } from "/app/pages/advice.vue?macro=true";
import { default as pricesgmF8usrEd4qjeWQ0NlDo_sGLaP3nvMEvZPZc8_eXxVcMeta } from "/app/pages/prices.vue?macro=true";
import { default as contactufjgRVR80M94tPXoOoARnsatRQ8kqFsigR6NqG_FbxIMeta } from "/app/pages/contact.vue?macro=true";
import { default as _91slug_93OY1eKGH50IeGHXpXb3BdZRgtgqHXLtURcDbb48n4NVYMeta } from "/app/pages/news/[slug].vue?macro=true";
import { default as indexI54zQzR8vYuL9MIj6Hdd74f4Gv6sumZMJcsMBZyd7B8Meta } from "/app/pages/cabinet/index.vue?macro=true";
import { default as indexEgzhaAvXJrRs5sUxaO2vJLnBwSFIHFB23ees6bkD2agMeta } from "/app/pages/invoice/index.vue?macro=true";
import { default as rodoO1chyY0Fp_52h4SiD7BIr1oEA0CiBosqiTRdHNMVf3AMeta } from "/app/pages/documents/rodo.vue?macro=true";
import { default as indexjRtHzhS_dpsR_NlfsCCACFtIpspax8jcPZapdKX7vF0Meta } from "/app/pages/services/index.vue?macro=true";
import { default as my_45info_eV7yvmFTUBI6x50U7bHF_EhvH9mpzjFo6vudMIgq50Meta } from "/app/pages/cabinet/my-info.vue?macro=true";
import { default as profile_0_w5Z8OR8ieTzFtHNCsortptxoLuFGX8ABspiT00UAMeta } from "/app/pages/cabinet/profile.vue?macro=true";
import { default as supportsFYpJbiNk4AD4msWXyEBOJ1W6nEl0clRXXMlE0G8v1UMeta } from "/app/pages/cabinet/support.vue?macro=true";
import { default as _91slug_93YJfOM5cIJxV5iFNDfI1c1ck_OTcSHE9gE8xz0Ebk6sIMeta } from "/app/pages/services/[slug].vue?macro=true";
import { default as restore_45passwordUmP_Ld9IYOddl_NNIcfdnn_HWgANZ8UqGFVOw4fQoK4Meta } from "/app/pages/restore-password.vue?macro=true";
import { default as dashboardzWyeycg7deG9HRfOz6_JjeJeiKWqUdgN2RosGMEGb9MMeta } from "/app/pages/cabinet/dashboard.vue?macro=true";
import { default as cookiesQyr3dIgbWoP6ScYcSujNo0ujvN4JtglVcfqCfbA1qmIMeta } from "/app/pages/documents/cookies.vue?macro=true";
import { default as editDMn4cCKz3x6j4luCaJZSzg6UpVOjurqmN1ndcsDSWmYMeta } from "/app/pages/invoice/[id]/edit.vue?macro=true";
import { default as statf_vELU6SsgZBhm8cBuSbl1z6aZ_BjILxndzL7lV6W2oMeta } from "/app/pages/cabinet/admin/stat.vue?macro=true";
import { default as index0ulAaAzf6V8Pya2T1A3trtnm2_ZuGh5phONeyoO2_IcMeta } from "/app/pages/cabinet/admin/index.vue?macro=true";
import { default as my_45invoicesMKpXgHGr_v7b1oHksG_YElD_U9jwAHCafvGyz7m9odgMeta } from "/app/pages/cabinet/my-invoices.vue?macro=true";
import { default as accountingrk2wAX4ta1UyJNtlstpqDh_30BbUDzVMhYa7IU7_GhwMeta } from "/app/pages/documents/accounting.vue?macro=true";
import { default as _91secret_93ZrVUMa3PIt_PewCkWccvgaZh0Zpk5A5ShqOLjejLt_MMeta } from "/app/pages/verify-email/[secret].vue?macro=true";
import { default as faqeA0nln72Cb0MU767D1lLR_MFSHbZ67qLB0AbsaJmOcsMeta } from "/app/pages/cabinet/admin/blog/faq.vue?macro=true";
import { default as managersaVASxtNFWsg_oUN9RKwwXVOE4blrm9w1KaMLptw4c30Meta } from "/app/pages/cabinet/admin/managers.vue?macro=true";
import { default as newsidrVl353gsv0x9ppiXhKFP0MYY7sn0zHLrNrvp8U_8YMeta } from "/app/pages/cabinet/admin/blog/news.vue?macro=true";
import { default as filesqBKfKzCI78GjruiulkpUMUTp_Bm5uvvSlgmBkpyQ__0Meta } from "/app/pages/cabinet/admin/blog/files.vue?macro=true";
import { default as indexpmZzDAHOxmkGSxPII2KRi6FiqFXXSEzcyX69GyuTmywMeta } from "/app/pages/cabinet/admin/blog/index.vue?macro=true";
import { default as linksPEA_9FtIAyf7_BUsL7Y5JKYzt6u_qL71jxwNHJDtoVcMeta } from "/app/pages/cabinet/admin/blog/links.vue?macro=true";
import { default as franchises5XdglN5osT6zXvHwVoWeygugSLMxD6AcHnwYkduW7EoMeta } from "/app/pages/cabinet/admin/franchises.vue?macro=true";
import { default as discount_45codes7FHPpH22aiFzW9wa3fzbGj3RrzJWpmcshZb6dqV9V1oMeta } from "/app/pages/documents/discount-codes.vue?macro=true";
import { default as editVkCO7QmLPoEkpIelXr6oXP1f_daU73DJZIFWIkqS3RsMeta } from "/app/pages/announcements/[slug]/edit.vue?macro=true";
import { default as index0ZKeiIpx1ftPOZvyNlz1gwvJyu67RXPWQV6FjgfaB64Meta } from "/app/pages/announcements/[slug]/index.vue?macro=true";
import { default as faqD1_nHI2BFR2W7_HEzRCqLOvu8J0iUEDbjIDt36OKzHkMeta } from "/app/pages/cabinet/admin/blog/new/faq.vue?macro=true";
import { default as franchiseTIjlDEioam9ahpuDeGJtjbCcja8HPLIprNraKf1ZMakMeta } from "/app/pages/announcements/new/franchise.vue?macro=true";
import { default as file5d2ul1GBnmVpmjZxfOc3KTBIBG5c75caJszzNWWoaowMeta } from "/app/pages/cabinet/admin/blog/new/file.vue?macro=true";
import { default as linknJ2M18S_dAc0sFFzLF3C7k4JL1lERkrsuWEpTQAwT1MMeta } from "/app/pages/cabinet/admin/blog/new/link.vue?macro=true";
import { default as newsSgoOrBazw70YT_UErJzFpoBNU0iDV9yfnR3iE_EIinIMeta } from "/app/pages/cabinet/admin/blog/new/news.vue?macro=true";
import { default as previewt30_hEGwVkCnV6fiqQEsomVQAOaIhE7mPcZ3_EzbQLwMeta } from "/app/pages/announcements/[slug]/preview.vue?macro=true";
import { default as investmentABY74NQdBs_oBaKiVhX2q1U2IKfqT8cYBqn9YNKo338Meta } from "/app/pages/announcements/new/investment.vue?macro=true";
import { default as business_45sale9oAevwJ_X9UU46HAA7GCbGTBV4Bx1_QSakVhLzO1EQoMeta } from "/app/pages/announcements/new/business-sale.vue?macro=true";
import { default as contacts_45requestsNyVrTjSHcZNbcoY_WnY2q0V4pQNxaFudURE7bS0YvecMeta } from "/app/pages/cabinet/admin/contacts-requests.vue?macro=true";
import { default as faqG3rysBlIaTvVmrx0HgoeR4ChzO_auzoi29Oypb4lkagMeta } from "/app/pages/cabinet/admin/blog/edit/[id]/faq.vue?macro=true";
import { default as fileS0uR_gB8BB6wZI48g6uUgUk0JE5S0oW4Jkc7X9AhntUMeta } from "/app/pages/cabinet/admin/blog/edit/[id]/file.vue?macro=true";
import { default as linkrfXjV1x1elMS6UGXjV6HNo1coKpqIlyxe64_NK1OV8wMeta } from "/app/pages/cabinet/admin/blog/edit/[id]/link.vue?macro=true";
import { default as newsS_6TUthfkjs_bBxYXiiS8dqaEO4Y2UdfHcqT61eZH5UMeta } from "/app/pages/cabinet/admin/blog/edit/[id]/news.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___uk",
    path: "/uk",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "advice___en",
    path: "/en/advice",
    component: () => import("/app/pages/advice.vue")
  },
  {
    name: "advice___uk",
    path: "/uk/advice",
    component: () => import("/app/pages/advice.vue")
  },
  {
    name: "advice___pl",
    path: "/pl/advice",
    component: () => import("/app/pages/advice.vue")
  },
  {
    name: "advice___ru",
    path: "/ru/advice",
    component: () => import("/app/pages/advice.vue")
  },
  {
    name: "prices___en",
    path: "/en/prices",
    component: () => import("/app/pages/prices.vue")
  },
  {
    name: "prices___uk",
    path: "/uk/prices",
    component: () => import("/app/pages/prices.vue")
  },
  {
    name: "prices___pl",
    path: "/pl/prices",
    component: () => import("/app/pages/prices.vue")
  },
  {
    name: "prices___ru",
    path: "/ru/prices",
    component: () => import("/app/pages/prices.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___uk",
    path: "/uk/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___pl",
    path: "/pl/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___ru",
    path: "/ru/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "news-slug___en",
    path: "/en/news/:slug()",
    component: () => import("/app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___uk",
    path: "/uk/news/:slug()",
    component: () => import("/app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___pl",
    path: "/pl/news/:slug()",
    component: () => import("/app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___ru",
    path: "/ru/news/:slug()",
    component: () => import("/app/pages/news/[slug].vue")
  },
  {
    name: "cabinet___en",
    path: "/en/cabinet",
    meta: { ...(indexI54zQzR8vYuL9MIj6Hdd74f4Gv6sumZMJcsMBZyd7B8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/cabinet/index.vue")
  },
  {
    name: "cabinet___uk",
    path: "/uk/cabinet",
    meta: { ...(indexI54zQzR8vYuL9MIj6Hdd74f4Gv6sumZMJcsMBZyd7B8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/cabinet/index.vue")
  },
  {
    name: "cabinet___pl",
    path: "/pl/cabinet",
    meta: { ...(indexI54zQzR8vYuL9MIj6Hdd74f4Gv6sumZMJcsMBZyd7B8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/cabinet/index.vue")
  },
  {
    name: "cabinet___ru",
    path: "/ru/cabinet",
    meta: { ...(indexI54zQzR8vYuL9MIj6Hdd74f4Gv6sumZMJcsMBZyd7B8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/cabinet/index.vue")
  },
  {
    name: "invoice___en",
    path: "/en/invoice",
    meta: indexEgzhaAvXJrRs5sUxaO2vJLnBwSFIHFB23ees6bkD2agMeta || {},
    component: () => import("/app/pages/invoice/index.vue")
  },
  {
    name: "invoice___uk",
    path: "/uk/invoice",
    meta: indexEgzhaAvXJrRs5sUxaO2vJLnBwSFIHFB23ees6bkD2agMeta || {},
    component: () => import("/app/pages/invoice/index.vue")
  },
  {
    name: "invoice___pl",
    path: "/pl/invoice",
    meta: indexEgzhaAvXJrRs5sUxaO2vJLnBwSFIHFB23ees6bkD2agMeta || {},
    component: () => import("/app/pages/invoice/index.vue")
  },
  {
    name: "invoice___ru",
    path: "/ru/invoice",
    meta: indexEgzhaAvXJrRs5sUxaO2vJLnBwSFIHFB23ees6bkD2agMeta || {},
    component: () => import("/app/pages/invoice/index.vue")
  },
  {
    name: "documents-rodo___en",
    path: "/en/documents/rodo",
    component: () => import("/app/pages/documents/rodo.vue")
  },
  {
    name: "documents-rodo___uk",
    path: "/uk/documents/rodo",
    component: () => import("/app/pages/documents/rodo.vue")
  },
  {
    name: "documents-rodo___pl",
    path: "/pl/documents/rodo",
    component: () => import("/app/pages/documents/rodo.vue")
  },
  {
    name: "documents-rodo___ru",
    path: "/ru/documents/rodo",
    component: () => import("/app/pages/documents/rodo.vue")
  },
  {
    name: "services___en",
    path: "/en/services",
    component: () => import("/app/pages/services/index.vue")
  },
  {
    name: "services___uk",
    path: "/uk/services",
    component: () => import("/app/pages/services/index.vue")
  },
  {
    name: "services___pl",
    path: "/pl/services",
    component: () => import("/app/pages/services/index.vue")
  },
  {
    name: "services___ru",
    path: "/ru/services",
    component: () => import("/app/pages/services/index.vue")
  },
  {
    name: "cabinet-my-info___en",
    path: "/en/cabinet/my-info",
    meta: { ...(my_45info_eV7yvmFTUBI6x50U7bHF_EhvH9mpzjFo6vudMIgq50Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/cabinet/my-info.vue")
  },
  {
    name: "cabinet-my-info___uk",
    path: "/uk/cabinet/my-info",
    meta: { ...(my_45info_eV7yvmFTUBI6x50U7bHF_EhvH9mpzjFo6vudMIgq50Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/cabinet/my-info.vue")
  },
  {
    name: "cabinet-my-info___pl",
    path: "/pl/cabinet/my-info",
    meta: { ...(my_45info_eV7yvmFTUBI6x50U7bHF_EhvH9mpzjFo6vudMIgq50Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/cabinet/my-info.vue")
  },
  {
    name: "cabinet-my-info___ru",
    path: "/ru/cabinet/my-info",
    meta: { ...(my_45info_eV7yvmFTUBI6x50U7bHF_EhvH9mpzjFo6vudMIgq50Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/cabinet/my-info.vue")
  },
  {
    name: "cabinet-profile___en",
    path: "/en/cabinet/profile",
    meta: { ...(profile_0_w5Z8OR8ieTzFtHNCsortptxoLuFGX8ABspiT00UAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/cabinet/profile.vue")
  },
  {
    name: "cabinet-profile___uk",
    path: "/uk/cabinet/profile",
    meta: { ...(profile_0_w5Z8OR8ieTzFtHNCsortptxoLuFGX8ABspiT00UAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/cabinet/profile.vue")
  },
  {
    name: "cabinet-profile___pl",
    path: "/pl/cabinet/profile",
    meta: { ...(profile_0_w5Z8OR8ieTzFtHNCsortptxoLuFGX8ABspiT00UAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/cabinet/profile.vue")
  },
  {
    name: "cabinet-profile___ru",
    path: "/ru/cabinet/profile",
    meta: { ...(profile_0_w5Z8OR8ieTzFtHNCsortptxoLuFGX8ABspiT00UAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/cabinet/profile.vue")
  },
  {
    name: "cabinet-support___en",
    path: "/en/cabinet/support",
    meta: { ...(supportsFYpJbiNk4AD4msWXyEBOJ1W6nEl0clRXXMlE0G8v1UMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/cabinet/support.vue")
  },
  {
    name: "cabinet-support___uk",
    path: "/uk/cabinet/support",
    meta: { ...(supportsFYpJbiNk4AD4msWXyEBOJ1W6nEl0clRXXMlE0G8v1UMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/cabinet/support.vue")
  },
  {
    name: "cabinet-support___pl",
    path: "/pl/cabinet/support",
    meta: { ...(supportsFYpJbiNk4AD4msWXyEBOJ1W6nEl0clRXXMlE0G8v1UMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/cabinet/support.vue")
  },
  {
    name: "cabinet-support___ru",
    path: "/ru/cabinet/support",
    meta: { ...(supportsFYpJbiNk4AD4msWXyEBOJ1W6nEl0clRXXMlE0G8v1UMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/cabinet/support.vue")
  },
  {
    name: "services-slug___en",
    path: "/en/services/:slug()",
    component: () => import("/app/pages/services/[slug].vue")
  },
  {
    name: "services-slug___uk",
    path: "/uk/services/:slug()",
    component: () => import("/app/pages/services/[slug].vue")
  },
  {
    name: "services-slug___pl",
    path: "/pl/services/:slug()",
    component: () => import("/app/pages/services/[slug].vue")
  },
  {
    name: "services-slug___ru",
    path: "/ru/services/:slug()",
    component: () => import("/app/pages/services/[slug].vue")
  },
  {
    name: "restore-password___en",
    path: "/en/restore-password",
    component: () => import("/app/pages/restore-password.vue")
  },
  {
    name: "restore-password___uk",
    path: "/uk/restore-password",
    component: () => import("/app/pages/restore-password.vue")
  },
  {
    name: "restore-password___pl",
    path: "/pl/restore-password",
    component: () => import("/app/pages/restore-password.vue")
  },
  {
    name: "restore-password___ru",
    path: "/ru/restore-password",
    component: () => import("/app/pages/restore-password.vue")
  },
  {
    name: "cabinet-dashboard___en",
    path: "/en/cabinet/dashboard",
    meta: { ...(dashboardzWyeycg7deG9HRfOz6_JjeJeiKWqUdgN2RosGMEGb9MMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/cabinet/dashboard.vue")
  },
  {
    name: "cabinet-dashboard___uk",
    path: "/uk/cabinet/dashboard",
    meta: { ...(dashboardzWyeycg7deG9HRfOz6_JjeJeiKWqUdgN2RosGMEGb9MMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/cabinet/dashboard.vue")
  },
  {
    name: "cabinet-dashboard___pl",
    path: "/pl/cabinet/dashboard",
    meta: { ...(dashboardzWyeycg7deG9HRfOz6_JjeJeiKWqUdgN2RosGMEGb9MMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/cabinet/dashboard.vue")
  },
  {
    name: "cabinet-dashboard___ru",
    path: "/ru/cabinet/dashboard",
    meta: { ...(dashboardzWyeycg7deG9HRfOz6_JjeJeiKWqUdgN2RosGMEGb9MMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/cabinet/dashboard.vue")
  },
  {
    name: "documents-cookies___en",
    path: "/en/documents/cookies",
    component: () => import("/app/pages/documents/cookies.vue")
  },
  {
    name: "documents-cookies___uk",
    path: "/uk/documents/cookies",
    component: () => import("/app/pages/documents/cookies.vue")
  },
  {
    name: "documents-cookies___pl",
    path: "/pl/documents/cookies",
    component: () => import("/app/pages/documents/cookies.vue")
  },
  {
    name: "documents-cookies___ru",
    path: "/ru/documents/cookies",
    component: () => import("/app/pages/documents/cookies.vue")
  },
  {
    name: "invoice-id-edit___en",
    path: "/en/invoice/:id()/edit",
    component: () => import("/app/pages/invoice/[id]/edit.vue")
  },
  {
    name: "invoice-id-edit___uk",
    path: "/uk/invoice/:id()/edit",
    component: () => import("/app/pages/invoice/[id]/edit.vue")
  },
  {
    name: "invoice-id-edit___pl",
    path: "/pl/invoice/:id()/edit",
    component: () => import("/app/pages/invoice/[id]/edit.vue")
  },
  {
    name: "invoice-id-edit___ru",
    path: "/ru/invoice/:id()/edit",
    component: () => import("/app/pages/invoice/[id]/edit.vue")
  },
  {
    name: "cabinet-admin-stat___en",
    path: "/en/cabinet/admin/stat",
    meta: { ...(statf_vELU6SsgZBhm8cBuSbl1z6aZ_BjILxndzL7lV6W2oMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/stat.vue")
  },
  {
    name: "cabinet-admin-stat___uk",
    path: "/uk/cabinet/admin/stat",
    meta: { ...(statf_vELU6SsgZBhm8cBuSbl1z6aZ_BjILxndzL7lV6W2oMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/stat.vue")
  },
  {
    name: "cabinet-admin-stat___pl",
    path: "/pl/cabinet/admin/stat",
    meta: { ...(statf_vELU6SsgZBhm8cBuSbl1z6aZ_BjILxndzL7lV6W2oMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/stat.vue")
  },
  {
    name: "cabinet-admin-stat___ru",
    path: "/ru/cabinet/admin/stat",
    meta: { ...(statf_vELU6SsgZBhm8cBuSbl1z6aZ_BjILxndzL7lV6W2oMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/stat.vue")
  },
  {
    name: "cabinet-admin___en",
    path: "/en/cabinet/admin",
    meta: { ...(index0ulAaAzf6V8Pya2T1A3trtnm2_ZuGh5phONeyoO2_IcMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/index.vue")
  },
  {
    name: "cabinet-admin___uk",
    path: "/uk/cabinet/admin",
    meta: { ...(index0ulAaAzf6V8Pya2T1A3trtnm2_ZuGh5phONeyoO2_IcMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/index.vue")
  },
  {
    name: "cabinet-admin___pl",
    path: "/pl/cabinet/admin",
    meta: { ...(index0ulAaAzf6V8Pya2T1A3trtnm2_ZuGh5phONeyoO2_IcMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/index.vue")
  },
  {
    name: "cabinet-admin___ru",
    path: "/ru/cabinet/admin",
    meta: { ...(index0ulAaAzf6V8Pya2T1A3trtnm2_ZuGh5phONeyoO2_IcMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/index.vue")
  },
  {
    name: "cabinet-my-invoices___en",
    path: "/en/cabinet/my-invoices",
    meta: { ...(my_45invoicesMKpXgHGr_v7b1oHksG_YElD_U9jwAHCafvGyz7m9odgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/cabinet/my-invoices.vue")
  },
  {
    name: "cabinet-my-invoices___uk",
    path: "/uk/cabinet/my-invoices",
    meta: { ...(my_45invoicesMKpXgHGr_v7b1oHksG_YElD_U9jwAHCafvGyz7m9odgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/cabinet/my-invoices.vue")
  },
  {
    name: "cabinet-my-invoices___pl",
    path: "/pl/cabinet/my-invoices",
    meta: { ...(my_45invoicesMKpXgHGr_v7b1oHksG_YElD_U9jwAHCafvGyz7m9odgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/cabinet/my-invoices.vue")
  },
  {
    name: "cabinet-my-invoices___ru",
    path: "/ru/cabinet/my-invoices",
    meta: { ...(my_45invoicesMKpXgHGr_v7b1oHksG_YElD_U9jwAHCafvGyz7m9odgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/cabinet/my-invoices.vue")
  },
  {
    name: "documents-accounting___en",
    path: "/en/documents/accounting",
    component: () => import("/app/pages/documents/accounting.vue")
  },
  {
    name: "documents-accounting___uk",
    path: "/uk/documents/accounting",
    component: () => import("/app/pages/documents/accounting.vue")
  },
  {
    name: "documents-accounting___pl",
    path: "/pl/documents/accounting",
    component: () => import("/app/pages/documents/accounting.vue")
  },
  {
    name: "documents-accounting___ru",
    path: "/ru/documents/accounting",
    component: () => import("/app/pages/documents/accounting.vue")
  },
  {
    name: "verify-email-secret___en",
    path: "/en/verify-email/:secret()",
    component: () => import("/app/pages/verify-email/[secret].vue")
  },
  {
    name: "verify-email-secret___uk",
    path: "/uk/verify-email/:secret()",
    component: () => import("/app/pages/verify-email/[secret].vue")
  },
  {
    name: "verify-email-secret___pl",
    path: "/pl/verify-email/:secret()",
    component: () => import("/app/pages/verify-email/[secret].vue")
  },
  {
    name: "verify-email-secret___ru",
    path: "/ru/verify-email/:secret()",
    component: () => import("/app/pages/verify-email/[secret].vue")
  },
  {
    name: "cabinet-admin-blog-faq___en",
    path: "/en/cabinet/admin/blog/faq",
    meta: { ...(faqeA0nln72Cb0MU767D1lLR_MFSHbZ67qLB0AbsaJmOcsMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/faq.vue")
  },
  {
    name: "cabinet-admin-blog-faq___uk",
    path: "/uk/cabinet/admin/blog/faq",
    meta: { ...(faqeA0nln72Cb0MU767D1lLR_MFSHbZ67qLB0AbsaJmOcsMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/faq.vue")
  },
  {
    name: "cabinet-admin-blog-faq___pl",
    path: "/pl/cabinet/admin/blog/faq",
    meta: { ...(faqeA0nln72Cb0MU767D1lLR_MFSHbZ67qLB0AbsaJmOcsMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/faq.vue")
  },
  {
    name: "cabinet-admin-blog-faq___ru",
    path: "/ru/cabinet/admin/blog/faq",
    meta: { ...(faqeA0nln72Cb0MU767D1lLR_MFSHbZ67qLB0AbsaJmOcsMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/faq.vue")
  },
  {
    name: "cabinet-admin-managers___en",
    path: "/en/cabinet/admin/managers",
    meta: { ...(managersaVASxtNFWsg_oUN9RKwwXVOE4blrm9w1KaMLptw4c30Meta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/managers.vue")
  },
  {
    name: "cabinet-admin-managers___uk",
    path: "/uk/cabinet/admin/managers",
    meta: { ...(managersaVASxtNFWsg_oUN9RKwwXVOE4blrm9w1KaMLptw4c30Meta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/managers.vue")
  },
  {
    name: "cabinet-admin-managers___pl",
    path: "/pl/cabinet/admin/managers",
    meta: { ...(managersaVASxtNFWsg_oUN9RKwwXVOE4blrm9w1KaMLptw4c30Meta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/managers.vue")
  },
  {
    name: "cabinet-admin-managers___ru",
    path: "/ru/cabinet/admin/managers",
    meta: { ...(managersaVASxtNFWsg_oUN9RKwwXVOE4blrm9w1KaMLptw4c30Meta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/managers.vue")
  },
  {
    name: "cabinet-admin-blog-news___en",
    path: "/en/cabinet/admin/blog/news",
    meta: { ...(newsidrVl353gsv0x9ppiXhKFP0MYY7sn0zHLrNrvp8U_8YMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/news.vue")
  },
  {
    name: "cabinet-admin-blog-news___uk",
    path: "/uk/cabinet/admin/blog/news",
    meta: { ...(newsidrVl353gsv0x9ppiXhKFP0MYY7sn0zHLrNrvp8U_8YMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/news.vue")
  },
  {
    name: "cabinet-admin-blog-news___pl",
    path: "/pl/cabinet/admin/blog/news",
    meta: { ...(newsidrVl353gsv0x9ppiXhKFP0MYY7sn0zHLrNrvp8U_8YMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/news.vue")
  },
  {
    name: "cabinet-admin-blog-news___ru",
    path: "/ru/cabinet/admin/blog/news",
    meta: { ...(newsidrVl353gsv0x9ppiXhKFP0MYY7sn0zHLrNrvp8U_8YMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/news.vue")
  },
  {
    name: "cabinet-admin-blog-files___en",
    path: "/en/cabinet/admin/blog/files",
    meta: { ...(filesqBKfKzCI78GjruiulkpUMUTp_Bm5uvvSlgmBkpyQ__0Meta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/files.vue")
  },
  {
    name: "cabinet-admin-blog-files___uk",
    path: "/uk/cabinet/admin/blog/files",
    meta: { ...(filesqBKfKzCI78GjruiulkpUMUTp_Bm5uvvSlgmBkpyQ__0Meta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/files.vue")
  },
  {
    name: "cabinet-admin-blog-files___pl",
    path: "/pl/cabinet/admin/blog/files",
    meta: { ...(filesqBKfKzCI78GjruiulkpUMUTp_Bm5uvvSlgmBkpyQ__0Meta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/files.vue")
  },
  {
    name: "cabinet-admin-blog-files___ru",
    path: "/ru/cabinet/admin/blog/files",
    meta: { ...(filesqBKfKzCI78GjruiulkpUMUTp_Bm5uvvSlgmBkpyQ__0Meta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/files.vue")
  },
  {
    name: "cabinet-admin-blog___en",
    path: "/en/cabinet/admin/blog",
    meta: { ...(indexpmZzDAHOxmkGSxPII2KRi6FiqFXXSEzcyX69GyuTmywMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/index.vue")
  },
  {
    name: "cabinet-admin-blog___uk",
    path: "/uk/cabinet/admin/blog",
    meta: { ...(indexpmZzDAHOxmkGSxPII2KRi6FiqFXXSEzcyX69GyuTmywMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/index.vue")
  },
  {
    name: "cabinet-admin-blog___pl",
    path: "/pl/cabinet/admin/blog",
    meta: { ...(indexpmZzDAHOxmkGSxPII2KRi6FiqFXXSEzcyX69GyuTmywMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/index.vue")
  },
  {
    name: "cabinet-admin-blog___ru",
    path: "/ru/cabinet/admin/blog",
    meta: { ...(indexpmZzDAHOxmkGSxPII2KRi6FiqFXXSEzcyX69GyuTmywMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/index.vue")
  },
  {
    name: "cabinet-admin-blog-links___en",
    path: "/en/cabinet/admin/blog/links",
    meta: { ...(linksPEA_9FtIAyf7_BUsL7Y5JKYzt6u_qL71jxwNHJDtoVcMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/links.vue")
  },
  {
    name: "cabinet-admin-blog-links___uk",
    path: "/uk/cabinet/admin/blog/links",
    meta: { ...(linksPEA_9FtIAyf7_BUsL7Y5JKYzt6u_qL71jxwNHJDtoVcMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/links.vue")
  },
  {
    name: "cabinet-admin-blog-links___pl",
    path: "/pl/cabinet/admin/blog/links",
    meta: { ...(linksPEA_9FtIAyf7_BUsL7Y5JKYzt6u_qL71jxwNHJDtoVcMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/links.vue")
  },
  {
    name: "cabinet-admin-blog-links___ru",
    path: "/ru/cabinet/admin/blog/links",
    meta: { ...(linksPEA_9FtIAyf7_BUsL7Y5JKYzt6u_qL71jxwNHJDtoVcMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/links.vue")
  },
  {
    name: "cabinet-admin-franchises___en",
    path: "/en/cabinet/admin/franchises",
    meta: { ...(franchises5XdglN5osT6zXvHwVoWeygugSLMxD6AcHnwYkduW7EoMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/franchises.vue")
  },
  {
    name: "cabinet-admin-franchises___uk",
    path: "/uk/cabinet/admin/franchises",
    meta: { ...(franchises5XdglN5osT6zXvHwVoWeygugSLMxD6AcHnwYkduW7EoMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/franchises.vue")
  },
  {
    name: "cabinet-admin-franchises___pl",
    path: "/pl/cabinet/admin/franchises",
    meta: { ...(franchises5XdglN5osT6zXvHwVoWeygugSLMxD6AcHnwYkduW7EoMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/franchises.vue")
  },
  {
    name: "cabinet-admin-franchises___ru",
    path: "/ru/cabinet/admin/franchises",
    meta: { ...(franchises5XdglN5osT6zXvHwVoWeygugSLMxD6AcHnwYkduW7EoMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/franchises.vue")
  },
  {
    name: "documents-discount-codes___en",
    path: "/en/documents/discount-codes",
    component: () => import("/app/pages/documents/discount-codes.vue")
  },
  {
    name: "documents-discount-codes___uk",
    path: "/uk/documents/discount-codes",
    component: () => import("/app/pages/documents/discount-codes.vue")
  },
  {
    name: "documents-discount-codes___pl",
    path: "/pl/documents/discount-codes",
    component: () => import("/app/pages/documents/discount-codes.vue")
  },
  {
    name: "documents-discount-codes___ru",
    path: "/ru/documents/discount-codes",
    component: () => import("/app/pages/documents/discount-codes.vue")
  },
  {
    name: "announcements-slug-edit___en",
    path: "/en/announcements/:slug()/edit",
    component: () => import("/app/pages/announcements/[slug]/edit.vue")
  },
  {
    name: "announcements-slug-edit___uk",
    path: "/uk/announcements/:slug()/edit",
    component: () => import("/app/pages/announcements/[slug]/edit.vue")
  },
  {
    name: "announcements-slug-edit___pl",
    path: "/pl/announcements/:slug()/edit",
    component: () => import("/app/pages/announcements/[slug]/edit.vue")
  },
  {
    name: "announcements-slug-edit___ru",
    path: "/ru/announcements/:slug()/edit",
    component: () => import("/app/pages/announcements/[slug]/edit.vue")
  },
  {
    name: "announcements-slug___en",
    path: "/en/announcements/:slug()",
    component: () => import("/app/pages/announcements/[slug]/index.vue")
  },
  {
    name: "announcements-slug___uk",
    path: "/uk/announcements/:slug()",
    component: () => import("/app/pages/announcements/[slug]/index.vue")
  },
  {
    name: "announcements-slug___pl",
    path: "/pl/announcements/:slug()",
    component: () => import("/app/pages/announcements/[slug]/index.vue")
  },
  {
    name: "announcements-slug___ru",
    path: "/ru/announcements/:slug()",
    component: () => import("/app/pages/announcements/[slug]/index.vue")
  },
  {
    name: "cabinet-admin-blog-new-faq___en",
    path: "/en/cabinet/admin/blog/new/faq",
    meta: { ...(faqD1_nHI2BFR2W7_HEzRCqLOvu8J0iUEDbjIDt36OKzHkMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/new/faq.vue")
  },
  {
    name: "cabinet-admin-blog-new-faq___uk",
    path: "/uk/cabinet/admin/blog/new/faq",
    meta: { ...(faqD1_nHI2BFR2W7_HEzRCqLOvu8J0iUEDbjIDt36OKzHkMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/new/faq.vue")
  },
  {
    name: "cabinet-admin-blog-new-faq___pl",
    path: "/pl/cabinet/admin/blog/new/faq",
    meta: { ...(faqD1_nHI2BFR2W7_HEzRCqLOvu8J0iUEDbjIDt36OKzHkMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/new/faq.vue")
  },
  {
    name: "cabinet-admin-blog-new-faq___ru",
    path: "/ru/cabinet/admin/blog/new/faq",
    meta: { ...(faqD1_nHI2BFR2W7_HEzRCqLOvu8J0iUEDbjIDt36OKzHkMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/new/faq.vue")
  },
  {
    name: "announcements-new-franchise___en",
    path: "/en/announcements/new/franchise",
    component: () => import("/app/pages/announcements/new/franchise.vue")
  },
  {
    name: "announcements-new-franchise___uk",
    path: "/uk/announcements/new/franchise",
    component: () => import("/app/pages/announcements/new/franchise.vue")
  },
  {
    name: "announcements-new-franchise___pl",
    path: "/pl/announcements/new/franchise",
    component: () => import("/app/pages/announcements/new/franchise.vue")
  },
  {
    name: "announcements-new-franchise___ru",
    path: "/ru/announcements/new/franchise",
    component: () => import("/app/pages/announcements/new/franchise.vue")
  },
  {
    name: "cabinet-admin-blog-new-file___en",
    path: "/en/cabinet/admin/blog/new/file",
    meta: { ...(file5d2ul1GBnmVpmjZxfOc3KTBIBG5c75caJszzNWWoaowMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/new/file.vue")
  },
  {
    name: "cabinet-admin-blog-new-file___uk",
    path: "/uk/cabinet/admin/blog/new/file",
    meta: { ...(file5d2ul1GBnmVpmjZxfOc3KTBIBG5c75caJszzNWWoaowMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/new/file.vue")
  },
  {
    name: "cabinet-admin-blog-new-file___pl",
    path: "/pl/cabinet/admin/blog/new/file",
    meta: { ...(file5d2ul1GBnmVpmjZxfOc3KTBIBG5c75caJszzNWWoaowMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/new/file.vue")
  },
  {
    name: "cabinet-admin-blog-new-file___ru",
    path: "/ru/cabinet/admin/blog/new/file",
    meta: { ...(file5d2ul1GBnmVpmjZxfOc3KTBIBG5c75caJszzNWWoaowMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/new/file.vue")
  },
  {
    name: "cabinet-admin-blog-new-link___en",
    path: "/en/cabinet/admin/blog/new/link",
    meta: { ...(linknJ2M18S_dAc0sFFzLF3C7k4JL1lERkrsuWEpTQAwT1MMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/new/link.vue")
  },
  {
    name: "cabinet-admin-blog-new-link___uk",
    path: "/uk/cabinet/admin/blog/new/link",
    meta: { ...(linknJ2M18S_dAc0sFFzLF3C7k4JL1lERkrsuWEpTQAwT1MMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/new/link.vue")
  },
  {
    name: "cabinet-admin-blog-new-link___pl",
    path: "/pl/cabinet/admin/blog/new/link",
    meta: { ...(linknJ2M18S_dAc0sFFzLF3C7k4JL1lERkrsuWEpTQAwT1MMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/new/link.vue")
  },
  {
    name: "cabinet-admin-blog-new-link___ru",
    path: "/ru/cabinet/admin/blog/new/link",
    meta: { ...(linknJ2M18S_dAc0sFFzLF3C7k4JL1lERkrsuWEpTQAwT1MMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/new/link.vue")
  },
  {
    name: "cabinet-admin-blog-new-news___en",
    path: "/en/cabinet/admin/blog/new/news",
    meta: { ...(newsSgoOrBazw70YT_UErJzFpoBNU0iDV9yfnR3iE_EIinIMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/new/news.vue")
  },
  {
    name: "cabinet-admin-blog-new-news___uk",
    path: "/uk/cabinet/admin/blog/new/news",
    meta: { ...(newsSgoOrBazw70YT_UErJzFpoBNU0iDV9yfnR3iE_EIinIMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/new/news.vue")
  },
  {
    name: "cabinet-admin-blog-new-news___pl",
    path: "/pl/cabinet/admin/blog/new/news",
    meta: { ...(newsSgoOrBazw70YT_UErJzFpoBNU0iDV9yfnR3iE_EIinIMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/new/news.vue")
  },
  {
    name: "cabinet-admin-blog-new-news___ru",
    path: "/ru/cabinet/admin/blog/new/news",
    meta: { ...(newsSgoOrBazw70YT_UErJzFpoBNU0iDV9yfnR3iE_EIinIMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/blog/new/news.vue")
  },
  {
    name: "announcements-slug-preview___en",
    path: "/en/announcements/:slug()/preview",
    component: () => import("/app/pages/announcements/[slug]/preview.vue")
  },
  {
    name: "announcements-slug-preview___uk",
    path: "/uk/announcements/:slug()/preview",
    component: () => import("/app/pages/announcements/[slug]/preview.vue")
  },
  {
    name: "announcements-slug-preview___pl",
    path: "/pl/announcements/:slug()/preview",
    component: () => import("/app/pages/announcements/[slug]/preview.vue")
  },
  {
    name: "announcements-slug-preview___ru",
    path: "/ru/announcements/:slug()/preview",
    component: () => import("/app/pages/announcements/[slug]/preview.vue")
  },
  {
    name: "announcements-new-investment___en",
    path: "/en/announcements/new/investment",
    component: () => import("/app/pages/announcements/new/investment.vue")
  },
  {
    name: "announcements-new-investment___uk",
    path: "/uk/announcements/new/investment",
    component: () => import("/app/pages/announcements/new/investment.vue")
  },
  {
    name: "announcements-new-investment___pl",
    path: "/pl/announcements/new/investment",
    component: () => import("/app/pages/announcements/new/investment.vue")
  },
  {
    name: "announcements-new-investment___ru",
    path: "/ru/announcements/new/investment",
    component: () => import("/app/pages/announcements/new/investment.vue")
  },
  {
    name: "announcements-new-business-sale___en",
    path: "/en/announcements/new/business-sale",
    component: () => import("/app/pages/announcements/new/business-sale.vue")
  },
  {
    name: "announcements-new-business-sale___uk",
    path: "/uk/announcements/new/business-sale",
    component: () => import("/app/pages/announcements/new/business-sale.vue")
  },
  {
    name: "announcements-new-business-sale___pl",
    path: "/pl/announcements/new/business-sale",
    component: () => import("/app/pages/announcements/new/business-sale.vue")
  },
  {
    name: "announcements-new-business-sale___ru",
    path: "/ru/announcements/new/business-sale",
    component: () => import("/app/pages/announcements/new/business-sale.vue")
  },
  {
    name: "cabinet-admin-contacts-requests___en",
    path: "/en/cabinet/admin/contacts-requests",
    meta: { ...(contacts_45requestsNyVrTjSHcZNbcoY_WnY2q0V4pQNxaFudURE7bS0YvecMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/contacts-requests.vue")
  },
  {
    name: "cabinet-admin-contacts-requests___uk",
    path: "/uk/cabinet/admin/contacts-requests",
    meta: { ...(contacts_45requestsNyVrTjSHcZNbcoY_WnY2q0V4pQNxaFudURE7bS0YvecMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/contacts-requests.vue")
  },
  {
    name: "cabinet-admin-contacts-requests___pl",
    path: "/pl/cabinet/admin/contacts-requests",
    meta: { ...(contacts_45requestsNyVrTjSHcZNbcoY_WnY2q0V4pQNxaFudURE7bS0YvecMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/contacts-requests.vue")
  },
  {
    name: "cabinet-admin-contacts-requests___ru",
    path: "/ru/cabinet/admin/contacts-requests",
    meta: { ...(contacts_45requestsNyVrTjSHcZNbcoY_WnY2q0V4pQNxaFudURE7bS0YvecMeta || {}), ...{"middleware":["auth","require-permission"]} },
    component: () => import("/app/pages/cabinet/admin/contacts-requests.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-faq___en",
    path: "/en/cabinet/admin/blog/edit/:id()/faq",
    meta: faqG3rysBlIaTvVmrx0HgoeR4ChzO_auzoi29Oypb4lkagMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/faq.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-faq___uk",
    path: "/uk/cabinet/admin/blog/edit/:id()/faq",
    meta: faqG3rysBlIaTvVmrx0HgoeR4ChzO_auzoi29Oypb4lkagMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/faq.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-faq___pl",
    path: "/pl/cabinet/admin/blog/edit/:id()/faq",
    meta: faqG3rysBlIaTvVmrx0HgoeR4ChzO_auzoi29Oypb4lkagMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/faq.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-faq___ru",
    path: "/ru/cabinet/admin/blog/edit/:id()/faq",
    meta: faqG3rysBlIaTvVmrx0HgoeR4ChzO_auzoi29Oypb4lkagMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/faq.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-file___en",
    path: "/en/cabinet/admin/blog/edit/:id()/file",
    meta: fileS0uR_gB8BB6wZI48g6uUgUk0JE5S0oW4Jkc7X9AhntUMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/file.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-file___uk",
    path: "/uk/cabinet/admin/blog/edit/:id()/file",
    meta: fileS0uR_gB8BB6wZI48g6uUgUk0JE5S0oW4Jkc7X9AhntUMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/file.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-file___pl",
    path: "/pl/cabinet/admin/blog/edit/:id()/file",
    meta: fileS0uR_gB8BB6wZI48g6uUgUk0JE5S0oW4Jkc7X9AhntUMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/file.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-file___ru",
    path: "/ru/cabinet/admin/blog/edit/:id()/file",
    meta: fileS0uR_gB8BB6wZI48g6uUgUk0JE5S0oW4Jkc7X9AhntUMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/file.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-link___en",
    path: "/en/cabinet/admin/blog/edit/:id()/link",
    meta: linkrfXjV1x1elMS6UGXjV6HNo1coKpqIlyxe64_NK1OV8wMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/link.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-link___uk",
    path: "/uk/cabinet/admin/blog/edit/:id()/link",
    meta: linkrfXjV1x1elMS6UGXjV6HNo1coKpqIlyxe64_NK1OV8wMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/link.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-link___pl",
    path: "/pl/cabinet/admin/blog/edit/:id()/link",
    meta: linkrfXjV1x1elMS6UGXjV6HNo1coKpqIlyxe64_NK1OV8wMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/link.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-link___ru",
    path: "/ru/cabinet/admin/blog/edit/:id()/link",
    meta: linkrfXjV1x1elMS6UGXjV6HNo1coKpqIlyxe64_NK1OV8wMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/link.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-news___en",
    path: "/en/cabinet/admin/blog/edit/:id()/news",
    meta: newsS_6TUthfkjs_bBxYXiiS8dqaEO4Y2UdfHcqT61eZH5UMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/news.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-news___uk",
    path: "/uk/cabinet/admin/blog/edit/:id()/news",
    meta: newsS_6TUthfkjs_bBxYXiiS8dqaEO4Y2UdfHcqT61eZH5UMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/news.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-news___pl",
    path: "/pl/cabinet/admin/blog/edit/:id()/news",
    meta: newsS_6TUthfkjs_bBxYXiiS8dqaEO4Y2UdfHcqT61eZH5UMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/news.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-news___ru",
    path: "/ru/cabinet/admin/blog/edit/:id()/news",
    meta: newsS_6TUthfkjs_bBxYXiiS8dqaEO4Y2UdfHcqT61eZH5UMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/news.vue")
  }
]